module.exports = {"selectCar":{"en":"Select My Car","es":"Seleccione el vehículo"},"reserve":{"en":"Reserve","es":"Reserve"},"vehicleInfo":{"en":"Vehicle Info","es":"Información del vehículo"},"pickupLocation":{"en":"Select your pick-up location","es":"Seleccione la oficina de retiro"},"dropoffLocation":{"en":"Select your return location","es":"Seleccione la oficina de devolución"},"selectTime":{"en":"Select time","es":"Seleccionar hora"}}


//////////////////
// WEBPACK FOOTER
// ./src/data/labels.json
// module id = 599
// module chunks = 168707334958949